import SvgCalendar from '@sats-group/icons/18/calendar';
import SvgTime from '@sats-group/icons/18/time';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import type { DateAndTime as Props } from './date-and-time.types';

const DateAndTime: React.FC<Props> = ({ date, time }) => (
  <div className="date-and-time">
    <div className="date-and-time__item">
      <SvgCalendar />
      <Text size={Text.sizes.small}>{date}</Text>
    </div>
    {time ? (
      <div className="date-and-time__item">
        <SvgTime />
        <Text size={Text.sizes.small}>{time}</Text>
      </div>
    ) : null}
  </div>
);

export default DateAndTime;
